<template>
  <main class="md:px-44 px-7">
    <!-- overLayGoBack -->
    <over-lay-go-back :starterOverLay="isOverLay" :isNoOneMoney="true" />
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import overLayGoBack from '../components/overLayGoBack.vue';

export default {
  name: 'One Money To Epl',
  components: { overLayGoBack },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      isOverLay: undefined,
    };
  },
  watch: {
  },
  methods: {
    init() {
      this.isOverLay = true;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
